/* eslint-disable import/no-unresolved */
import HelmetConfig from '@/components/HelmetConfig';

import Routes from '@/routes';

const App = () => (
  <HelmetConfig>
    <Routes />
  </HelmetConfig>
);

export default App;
